import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef, useRef, useEffect } from 'react';
import { TextInput } from '@paypalcorp/pp-react-text-input';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { ViewIcon, HideIcon } from '@paypalcorp/pp-react-icons';

var _excluded = ["as", "isHidden", "hideToggleLabel", "onToggleHide", "value"];

var PasswordInput = forwardRef(function (props, ref) {
  var as = props.as,
      _props$isHidden = props.isHidden,
      isHidden = _props$isHidden === void 0 ? true : _props$isHidden,
      hideToggleLabel = props.hideToggleLabel,
      onToggleHide = props.onToggleHide,
      value = props.value,
      rest = _objectWithoutProperties(props, _excluded);

  var internalRef = useRef();
  var inputRef = ref || internalRef;
  useEffect(function () {
    var inputElm = inputRef.current;

    if (inputElm && (value === null || value === void 0 ? void 0 : value.length)) {
      /* istanbul ignore next */
      // without timeout setSelectionRange run first then component re-render hence cursor position is not restored
      requestAnimationFrame(function () {
        inputElm.setSelectionRange(value.length, value.length); //restore cursor to the last char
      });
    }
  }, [isHidden]);
  var typeProp = isHidden ? {
    type: 'password'
  } : {};
  var iconButtonLabel = hideToggleLabel || (isHidden ? 'show' : 'hide');
  return /*#__PURE__*/React.createElement(as || TextInput, _extends({
    ref: inputRef,
    rightIcon: /*#__PURE__*/React.createElement(IconButton, {
      buttonType: "tertiary",
      svgIconComponent: isHidden ? ViewIcon : HideIcon,
      onClick: function handleHideToggleClick() {
        /* istanbul ignore next */
        if (onToggleHide) {
          onToggleHide(!isHidden);
        }
      },
      onMouseDown: function onMouseDown(evt) {
        return evt.preventDefault();
      },
      "data-ppui": "true"
    }, iconButtonLabel),
    value: value,
    "data-ppui-info": "password-input_2.1.25"
  }, typeProp, rest));
});

export { PasswordInput };
